module.exports = __webpack_public_path__ + "static/media/Jobs.2adbab80.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/Industries/Jobs.svg
// module id = 319
// module chunks = 0